module.exports = __webpack_public_path__ + "img/additional-savings-grid-button.f9b2d7e5.gif";